import React, { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useSettings } from '../settings/shared';
import { translate } from '../password/model';
import baseline from '../../app-ui/baseline';
import { withoutCallbackSecrets } from './model';
import { removeLegacyDraft } from './draft';
import './Signup.css';
export function useSignupStyle() {
  const { style, locale, dark } = useSettings();
  return {
    locale,
    t: (k, v) => translate(locale, k, v),
    style: {
      ...style,
      '--password-surface': baseline.tokens[dark ? 'darkColors' : 'lightColors'].surface,
    },
  };
}
export function useCleanCallbackUrl() {
  const location = useLocation();
  useLayoutEffect(() => {
    removeLegacyDraft();
    // Keep sensitive values only in this mounted route's memory, not the browser URL.
    if (window.location.pathname === location.pathname) {
      const search = withoutCallbackSecrets(location.search);
      if (search !== window.location.search)
        window.history.replaceState(
          window.history.state,
          '',
          location.pathname + search + location.hash,
        );
    }
  }, [location.pathname, location.search, location.hash]);
}
export function Agreement({ checked, onChange, t, age = false }) {
  const terms = t('auth.terms'),
    privacy = t('auth.privacy'),
    message = t(age ? 'auth.ageAgreement' : 'auth.agreeTerms');
  const parts = age
    ? [message]
    : message.split(
        new RegExp(
          '(' +
            [terms, privacy].map((s) => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).join('|') +
            ')',
          'g',
        ),
      );
  return (
    <label className={'pp-signup-agreement' + (age ? ' is-age' : '')}>
      <input
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        aria-label={message}
      />
      <span>
        {parts.map((part, i) =>
          part === terms || part === privacy ? (
            <a
              key={i}
              href={part === terms ? '/about/terms-of-use' : '/about/privacy-policy'}
              target="_blank"
              rel="noopener noreferrer"
              onClick={(e) => e.stopPropagation()}
            >
              {part}
            </a>
          ) : (
            part
          ),
        )}
      </span>
    </label>
  );
}
